module.exports = __webpack_public_path__ + "static/parade-2020-house57-44a01f1cab7fa1e55a56c2699e4a0452.jpg";